export interface ZmanimData {
  shabbat_start?: string;
  shabbat_end?: string;
  sunrise?: string;
  sunset?: string;
  chatzot?: string;
  alot_hashachar?: string;
  tzeit_hakochavim?: string;
  [key: string]: string | undefined;
}

// Default constants for Hadera, Israel
export const HADERA_COORDINATES = {
  lat: 32.4340,
  lng: 34.9197,
  city: "Hadera",
  country: "IL",
  tzid: "Asia/Jerusalem"
};

export interface UserLocation {
  lat: number;
  lng: number;
  name?: string;
  city?: string;
  country?: string;
  tzid?: string;
}

export interface TimeItem {
  id: string;
  title: string;
  time: string;
  prayer_type?: string;
  is_relative?: boolean;
  relative_to?: string;
  offset_minutes?: number;
  show_time?: boolean;
  calculatedTime?: string;
} 